"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrrigationZone = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'IrrigationZone';
/**
 * @deprecated SHOULD BE COMPLETELY GONE
 */
class IrrigationZone extends datamodel_core_1.ModelCommon {
    constructor(ob) {
        super(ob.type || typeName, ob);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'Name of the Zone eg south field' },
            comments: { type: 'String', editable: true, label: 'Comments', name: 'comments', description: 'Space for comments ' },
        };
    }
}
exports.IrrigationZone = IrrigationZone;
